
<template>
  
  <div  class="product-container" :mode="displayMode">
    <div
      class="product-grid"
      :flyer-orientation="flyerOrientation"
      page-id="searchResults"
      :class="{
        update: zIndex,
        update2: !zIndex,
        'card-view': CardView,
        'no-gap': noGapAttr,
        'disable-popup': isDisablePopup,
        scrollable: filteredProducts.length > 10
      }"
      :style="currentGridStyle"
      :root-scroll-container="rootScrollContainer"
    >
      <div
        v-for="(product, cardKey) in filteredProducts"
        :key="cardKey"
        class="product-card"
        tabindex="0"
        :class="{
          'flex-50': filteredProducts.length < 10,
          'flex-25': filteredProducts.length >= 10
        }"
        @click="onClick(product)"
      >
        <div class="content">
          <div class="product-image">
			<img 
				v-if="product.productImage && product.productImage.trim() !== ''" 
				:src="product.productImage" 
				alt=""
				loading="lazy"
			>
			<div v-else class="no-image"></div>
			</div>

          <div class="price-row" v-if="product.salePrice !== null">
            <span class="product-price" :class="fontSizeClass">${{ product.salePrice }}</span>
            <span
              class="product-reg-price"
              :class="fontSizeClass"
              v-if="product.regularPrice !== product.salePrice"
            >
              ${{ product.regularPrice }}
            </span>
          </div>

          <p
            class="savings"
            :class="fontSizeClass"
            v-if="product.saveInt !== 0 && !isNaN(product.regularPrice - product.salePrice)"
          >
            {{ saveLabel }} {{ product.save }}
            (${{ (product.regularPrice - product.salePrice).toFixed(2) }})
          </p>

          <p class="product-name" :class="fontSizeClass">{{ product.brandDescription }}</p>
          <p class="product-desc" :class="fontSizeClass">{{ productDesc(product) }}</p>

          <p v-if="product.sku" class="product-number" :class="fontSizeClass">
            #{{ product.sku }}
          </p>
        </div>
      </div>
    </div>
  </div>
</template>


<script>
import { mapGetters, mapState, mapActions } from "vuex";
import blockElementMixin from "@/mixins/blockElementMixin";
import {PRODUCT_REGION_CLICK} from "@/components/block/BlockEvents";


export default {
	name: "SearchResultTiledView",
	mixins: [blockElementMixin],
	props: [
     "flyerPages",
    "rootScrollContainer",
	"isGridView"
  ],
	
	data() {
		
		return {
			products: [
			],
			 zIndex: false,
			finelineNMs: [],
			lastcategory: [],
			cardKey:0,
			gridSize: 'grid-default',
			LayoutDirections: {
				HORIZONTAL: 0,
				VERTICAL: 1
			},
			saveLabel: 'Save',
		
	}},
	
	computed: {
		...mapState(['CardView']),
		...mapGetters('ctUser', ['canViewTriangleRewards', 'isSignedIn', 'offerViewMode', 'hasOffers', 'isLoggedIntoCT', 'hasTriangleID']),
		...mapGetters(['content', 'language', 'storeId']),
		...mapGetters('screen', ['displayMode', 'flyerOrientation']),
		...mapGetters('landingPage', ['currentFlyer']),
		...mapState('search', ['pricing','loading']),
		...mapGetters(['TiledView']),


		filteredProducts() {
			if (!this.products || !Array.isArray(this.products)) {
			return [];
			}
			
			return this.products
			.filter(product => product.sku && product.sku !== "") // remove empty/repetitive SKU
			.sort((a, b) => (b.saveInt || 0) - (a.saveInt || 0)); // sort by savings
		},

    	isVerticalOnDesktop() {
			return this.displayMode === 'desktop' && this.flyerOrientation === 'vertical';
		},
		
		isPreviewFlyer() {
			return this.isLoggedIntoCT && this.hasTriangleID && this.offerViewMode === 'preview';
		},
		 isDisablePopup() {
        let flyerCategory = this.currentFlyer?.flyerCategory
	      return this.features?.otherPublications?.disablePopup && (flyerCategory?.includes('Other Publication - Responsive')
	       || flyerCategory?.includes('Specialty Book'));

		},
		noGapAttr(){
		return this.flyerPages.some(page=> page.noGapAfterPage) 
		},
		currentGridStyle: function () {
			const styles = {
				0: {
				gridTemplateColumns: `repeat(${this.flyerPages.length},max-content)`
				},
				1: {
				gridTemplateRows: `repeat(${this.flyerPages.length},max-content)`
				}
			};
			return styles[this.currentLayoutDirection];
			},

		currentLayoutDirection(){
      		return this.flyerOrientation == 'vertical'? this.LayoutDirections.VERTICAL : this.LayoutDirections.HORIZONTAL;
   		 },
		fontSizeClass() {
		 const count = this.filteredProducts?.length || 0;
		if (count < 5) return 'font-few';       // fewer items → smaller font
		if (count <= 10) return 'font-normal';  // medium count
		return 'font-small'; 
		},	
	},
	
	watch: { 		  //Every time flyerPages is set or changed, check if we're in Grid View and have at least one page.
					//  If so, run fetchProducts()
		flyerPages: {
			
				handler(newVal) {
				
				if (this.isGridView && newVal && newVal.length) {
					this.fetchProducts();
				}
				},
			
    		immediate: true//runs once right away when the component is created
		},
		
		
	},
	
	methods: {
		...mapActions('events', ['triggerEvent']),
		
		fetchProducts() {
			
			if (!Array.isArray(this.flyerPages)) {
				this.products = Object.freeze([]);
				return;
			}
			
			this.products = Object.freeze(
				this.flyerPages
				
				.map(product => ({
					...product,
					numericPrice: parseFloat(product.regularPrice) // numeric for filtering/sorting
				}))
			);
			},

		productDesc(product) {
			const desc = (this.language === 'fr') ? product.productFr : product.productEn;
			if (!desc) return ""; // handle empty/null safely

			const firstSentence = desc.split('.')[0];
			return firstSentence.trim() + (desc.includes('.') ? '.' : '');
			},
		onClick(product) {
			
		this.triggerEvent({  event: PRODUCT_REGION_CLICK,
                  data: {product, language: this.language,
                    storeId: this.storeId}})
	
		},
		

	},
}
</script>
<style lang="scss">
.product-container {
  max-width: 142vh;
  transform-origin: top left;
  background-color: #fff;
  overflow: auto; 
  position: relative;
 height: 100%; 
  top: -13px;
  top: 0;
  display: flex; 
  column-gap: 20px;
  row-gap: 20px; 
  transition: 0.2s transform;
  justify-content: center;
//Only these 2 if they want flyerview for cardview(horizental)
	//display: flex;
 	// justify-content: center;
//
  .product-grid {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
    //padding: 20px;
    justify-content: flex-start; 
    align-content: flex-start;
	
	overflow-x: hidden;
    &.scrollable {
	max-height: 620px; 
	  overflow-y: visible;
    }
	&.noscroll {
     max-height: none;
	overflow-y: visible;
	justify-content: center; 
	}
    .product-card {
      max-width: 140px;
   		border: 1px solid #f7f7f7;

	  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
      padding: 8px;
      background: white;
      position: relative;
      cursor: pointer;

      .content {
        display: block;
        flex-direction: column;
        align-items: center;
       
        .product-image {
          height: 100px;
          width: 100%;
          display: flex;
          justify-content: center;
          align-items: center;
          
          img {
            max-height: 100px;
            max-width: 100%;
            
          }
		   .no-image {
			width: 100%;
			height: 100px;
			background: url("/images/noimage.svg")center center / contain no-repeat;
			
			}
        }

       .product-name {
			margin: 5px 0 0 0;
			text-transform: uppercase;

			&.font-small {
				font-size: 6px;
				font-weight: bold;
			}

			&.font-normal {
				font-size: 8px;
				font-weight: bold;
			}
			&.font-few {
				font-size: 4px !important;
				font-weight: bold;
				
				}
		}

       .price-row {
			display: flex;
			align-items: baseline;
			gap: 4px;
			margin-top: 5px;
			margin-left: 1px;

			.product-price {
				font-size: 11px;
				font-weight: 600;
				color: #e21111;
			&.font-few {
				font-size: 6px !important;
			}

			&.font-normal {
				font-size: 10px;
			}

			&.font-small {
				font-size: 9px;
			}
			}

			.product-reg-price {
				font-size: 10px;
				color: #8b8e92;
				text-decoration: line-through;
				&.font-few {
				font-size: 6px !important;
			}

			&.font-normal {
				font-size: 10px;
			}

			&.font-small {
				font-size: 9px;
			}
			}
			}

        .savings {
           color: #8b8e92;
         font-size: 11px;
         margin-top: auto; 
   		 padding-top: 5px;
		  &.font-few {
				font-size: 6px !important;
			}

			&.font-normal {
				font-size: 11px;
			}

			&.font-small {
				font-size: 9px;
			}
				
        }

        .product-desc {
          line-height: normal;
          font-size: 8px;
           margin: 0 0 2px 0;
		   &.font-small {
				font-size: 8px;
				
			}

			&.font-normal {
				font-size: 8px;
				
			}
			&.font-few {
				font-size: 6px !important;
				line-height: 1.1;
				}
        }
		.product-number {
			color: #8b8e92;
			margin-top: auto;
			padding-top: 5px;

			&.font-small {
				font-size: 6px;
				font-weight: 200;
			}

			&.font-normal {
				font-size: 8px;
				font-weight: 200;
			}
			&.font-few {
				font-size: 4px !important;
				font-weight: bold;
				line-height: 1.1;
				}
		}
		
      }
    }
		
    .flex-25 {
     
	  flex: 1 0 calc(80% - 8px); 
  		width: 80px;
    }

   .flex-50 {
	//    flex: 1 0 calc(100% - 5px); 
	// 	width: 60px;    

  	flex: 1 0 calc(50% - 8px);  // 2 per row
 	 width: 80px;
	}
	
  }
 
}

</style>
<style lang="scss">
.product-container[mode='mobile']  {
  max-width: 100vw;
  padding: 0;
  margin: 0;
  box-sizing: border-box;

  .product-grid {
    width: 100vw;
    max-width: 100%;
    margin: 0 auto;
    padding: 0 8px;
    box-sizing: border-box;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    gap: 8px;
	&.scrollable {
      max-height: none;
      overflow-y: visible;
    }
   
    .product-card {
      flex: 1 0 calc(50% - 12px);
        max-width: calc(50% - 12px);
        box-sizing: border-box;
        padding: 8px 4px;

      .product-name,
      .product-desc {
        font-size: 0.8em;
        line-height: 1.2;
		word-wrap: break-word;
  		overflow-wrap: break-word;
      }
      .product-number {
        font-size: 0.8em;
        line-height: 1.2;
      }

      .price-row {
        .product-price {
          font-size: 1em;
        }

        .product-reg-price {
          font-size: 0.9em;
        }
      }
    }
  }
}


.product-container[mode='tablet'] {
  display: flex;
  justify-content: center; // center the grid block itself

  .product-grid[flyer-orientation='vertical'] {
    max-width: 650px;
    width: 100%;
    margin: 0 auto;
    padding:5px 30px;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start; // ensures last row cards stick left
    gap: 8px;

    &.scrollable {
      max-height: none;
      overflow-y: visible;
    }

    .flex-50 {
      flex: 1 0 calc(100% - 8px);
      width: 140px;
    }
  }
}

.product-container[mode='desktop']{
  .product-grid[flyer-orientation='vertical'] {
	 max-width: 650px;
    
	  &.scrollable {
      max-height: none;       
      overflow-y: visible;   
    }
   
   .flex-50 {
      flex: 1 0 calc(100% - 8px);  
		width: 140px;
    }
  }
}

</style>
    
